import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import clienteService from "../services/cliente.service";

const initialState = {
    clientes: [],
    isLoading: false,
    isError: false,
    message: '',// Mensaje de error general
    currentPage: 1,
    totalRows: 0,
    errorGetClienteByDni: null, // Error específico para getClienteByDni
    errorGetClientes: null, // Error específico para getClientes
    numeroSiguienteFactura: null, // Campo para almacenar el siguiente número de factura
    numeroSiguientePresupuesto : null 
};



export const getClientes = createAsyncThunk(
    "clientes/getClientes",
    async (data, thunkAPI) => {
        try {
            return await clienteService.getAllClientes(data);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const createCliente = createAsyncThunk(
    "cliente/create",
    async ( clienteData, thunkAPI ) => {
        try {
            return await clienteService.createCliente(clienteData);
        } catch (error) {
            const message = 
            (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const updateCliente = createAsyncThunk(
    "cliente/update",
    async (clienteData, thunkAPI ) => {
        try {
            const token = thunkAPI.getState().auth.user.token;
            return await clienteService.updateCliente(clienteData, token);
        } catch (error) {
            const message = (error.response && 
                error.response.data && 
                error.response.data.message) || 
                error.message || 
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const deleteCliente = createAsyncThunk(
    "clientes/deleteCliente",
    async (id, thunkAPI) => {
        try {
            return await clienteService.deleteCliente(id);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const getClienteByDni = createAsyncThunk(
    "clientes/getClienteByDni",
    async (dni, thunkAPI) => {
        try {
            return await clienteService.getClienteByDni(dni);
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)


export const getSiguienteNroFactura = createAsyncThunk(
    "facturas/getSiguienteNroFactura",
    async (thunkAPI) => {
        try {
            return await clienteService.getSiguienteNroFactura();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
)

export const getSiguienteNroPresupuesto = createAsyncThunk(
    "presupuesto/getSiguienteNroPresupuesto",
    async (thunkAPI) => {
        try {
            return await clienteService.getSiguienteNroPresupuesto();
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString();
            return thunkAPI.rejectWithValue(message);
        }
    }
);

export const clienteSlice = createSlice({
    name: "clientes",
    initialState,
    reducers: {
        reset: (state) => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(getClientes.pending, (state) => {
                state.isLoading = true;
                state.errorGetClientes = null; // Limpia el error específico
            })
            .addCase(getClientes.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.clientes = action.payload.data; // Asegúrate de que el backend retorne los datos bajo esta estructura
                state.currentPage = action.payload.pagination.por_pagina;
                state.totalRows = action.payload.pagination.cantidad;
            })
            .addCase(getClientes.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.errorGetClientes = action.payload; // Guarda el error específico
            })
            .addCase(createCliente.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(createCliente.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.clientes.push(action.payload);
            })
            .addCase(createCliente.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.clientes = [action.payload]; // Lo forzas a ser un array
            })
            .addCase(deleteCliente.fulfilled, (state, action) => {
                state.isLoading = false;
                state.clientes = state.clientes.filter(cliente => cliente.id !== action.meta.arg); // Opcional si quieres filtrar localmente
            })
            .addCase(deleteCliente.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload || 'Error eliminando el cliente';
            })
            .addCase(updateCliente.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(updateCliente.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isSuccess = true;
                state.clientes = state.clientes.map((cliente) => 
                cliente.id === action.payload.id ? action.payload : cliente);
            })
            .addCase(updateCliente.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload;
            })
            .addCase(getClienteByDni.pending, (state) => {
                state.isLoading = true;
                state.errorGetClienteByDni = null; // Limpia el error específico
            })
            .addCase(getClienteByDni.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.clientes = action.payload; // Almacena directamente los datos del cliente
            })
            .addCase(getClienteByDni.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.errorGetClienteByDni = action.payload; // Guarda el error específico
            })
            .addCase(getSiguienteNroFactura.pending, (state) => {
                state.isLoading = true;
                state.message = null; // Limpia el error específico
            })
            .addCase(getSiguienteNroFactura.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.numeroSiguienteFactura = action.payload; // Crea un campo nuevo
               // state.clientes = action.payload; // Almacena directamente los datos del cliente
            })
            .addCase(getSiguienteNroFactura.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Guarda el error específico
            })
            .addCase(getSiguienteNroPresupuesto.pending, (state) => {
                state.isLoading = true;
                state.message = null; // Limpia el error específico
            })
            .addCase(getSiguienteNroPresupuesto.fulfilled, (state, action) => {
                state.isLoading = false;
                state.isError = false;
                state.numeroSiguientePresupuesto = action.payload; // Crea un campo nuevo
               // state.clientes = action.payload; // Almacena directamente los datos del cliente
            })
            .addCase(getSiguienteNroPresupuesto.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
                state.message = action.payload; // Guarda el error específico
            });
        }
})

export const { reset } = clienteSlice.actions;
export default clienteSlice.reducer;